module.exports = __webpack_public_path__ + "img/riviera-chichen.1de061c2.jpg";